import { Unit_instance3kz1zqli6gr1r as Unit_instance } from '../../../../../../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
import { launch1c91vkjzdi9sd as launch } from '../../../../../../../kotlinx-coroutines-core/kotlinx/coroutines/Builders.common.mjs';
import { ArrayList3it5z8td81qkl as ArrayList } from '../../../../../../../kotlin-kotlin-stdlib/kotlin/collections/ArrayListJs.mjs';
import {
  cancel36mj9lv3a0whl as cancel,
  CoroutineScopelux7s7zphw7e as CoroutineScope,
} from '../../../../../../../kotlinx-coroutines-core/kotlinx/coroutines/CoroutineScope.mjs';
import { delay2kng7ucb3aj62 as delay } from '../../../../../../../kotlinx-coroutines-core/kotlinx/coroutines/Delay.mjs';
import {
  ApolloNetworkException3denf70pfh242 as ApolloNetworkException,
  SubscriptionConnectionException12fjxvnnqzby5 as SubscriptionConnectionException,
  ApolloWebSocketClosedException26hvn543pf46i as ApolloWebSocketClosedException,
  DefaultApolloException8w3ielfxng0h as DefaultApolloException,
} from '../../../../../../../apollo-kotlin-apollo-api/com/apollographql/apollo/exception/Exceptions.mjs';
import { orPromise1iucc2to2udt2 as orPromise } from '../../../../../../../kotlin-kotlin-stdlib/kotlin/coroutines/intrinsics/coroutinesInteropJs.mjs';
import { constructCallableReference23y65rf941mch as constructCallableReference } from '../../../../../../../kotlin-kotlin-stdlib/kotlin/js/reflectRuntime.mjs';
import { get_atomicfu$reentrantLock3o926yhldwf1 as get_atomicfu$reentrantLock } from '../../../../../../../kotlinx-atomicfu/kotlinx/atomicfu/locks/Synchronized.mjs';
import { Dispatchers_getInstance128lm494a5r5s as Dispatchers_getInstance } from '../../../../../../../kotlinx-coroutines-core/kotlinx/coroutines/Dispatchers.mjs';
import { LinkedHashMap1zhqxkxv3xnkl as LinkedHashMap } from '../../../../../../../kotlin-kotlin-stdlib/kotlin/collections/LinkedHashMap.mjs';
import { Collection1k04j3hzsbod0 as Collection } from '../../../../../../../kotlin-kotlin-stdlib/kotlin/collections/Collections.mjs';
import { isInterface3d6p8outrmvmk as isInterface } from '../../../../../../../kotlin-kotlin-stdlib/kotlin/js/typeCheckUtils.mjs';
import { HttpHeader1d7ldebjomr00 as HttpHeader } from '../../../../../../../apollo-kotlin-apollo-api/com/apollographql/apollo/api/http/Http.mjs';
import {
  plus20p0vtfmu0596 as plus,
  toList3jhuyej2anx2q as toList,
} from '../../../../../../../kotlin-kotlin-stdlib/kotlin/collections/_Collections.mjs';
import {
  noWhenBranchMatchedException2a6r7ubxgky5j as noWhenBranchMatchedException,
  ensureNotNull1e947j3ixpazm as ensureNotNull,
} from '../../../../../../../kotlin-kotlin-stdlib/kotlin/hacks.mjs';
import {
  ConnectionKeepAliveServerMessage_instance39en4v9fbt32i as ConnectionKeepAliveServerMessage_instance,
  PongServerMessage_instancew68t57iujoli as PongServerMessage_instance,
  PingServerMessage_instance3gqk60x9xj12k as PingServerMessage_instance,
  ParseErrorServerMessage28gxznaow3b26 as ParseErrorServerMessage,
  OperationErrorServerMessage3f3enfqsilvrv as OperationErrorServerMessage,
  CompleteServerMessage1c62v9ocjho2f as CompleteServerMessage,
  ResponseServerMessage1aifb0dqdz3sq as ResponseServerMessage,
  ConnectionErrorServerMessage21355wd69v8tf as ConnectionErrorServerMessage,
  ConnectionAckServerMessage_instance2m47rw1rcdnts as ConnectionAckServerMessage_instance,
} from '../ServerMessage.mjs';
import { equals2au1ep9vhcato as equals } from '../../../../../../../kotlin-kotlin-stdlib/kotlin/js/coreRuntime.mjs';
import { println2shhhgwwt4c61 as println } from '../../../../../../../kotlin-kotlin-stdlib/kotlin/io/console.mjs';
import { Duration5ynfiptaqcrg as Duration } from '../../../../../../../kotlin-kotlin-stdlib/kotlin/time/Duration.mjs';
import { decodeToString1x4faah2liw2p as decodeToString } from '../../../../../../../kotlin-kotlin-stdlib/kotlin/text/stringJs.mjs';
import { initMetadataForClassbxx6q50dy2s7 as initMetadataForClass } from '../../../../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { Enum3alwj03lh1n41 as Enum } from '../../../../../../../kotlin-kotlin-stdlib/kotlin/Enum.mjs';
import {
  DataClientMessage3splhk6u8gldd as DataClientMessage,
  TextClientMessage15942w7lyj1yt as TextClientMessage,
} from '../ClientMessage.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
function restartIdleTimeout($this) {
  var tmp0_safe_receiver = $this.j6b_1;
  if (tmp0_safe_receiver == null)
    null;
  else {
    tmp0_safe_receiver.hy();
  }
  var tmp = $this;
  tmp.j6b_1 = launch($this.i6b_1, VOID, VOID, SubscribableWebSocket$restartIdleTimeout$slambda($this));
}
function shutdownInternal($this, cause) {
  // Inline function 'kotlin.collections.mutableListOf' call
  var listeners = ArrayList().p2();
  // Inline function 'kotlinx.atomicfu.locks.withLock' call
  $this.h6b_1;
  if ($this.l6b_1.equals(SocketState_ShutDown_getInstance())) {
    return Unit_instance;
  }
  $this.l6b_1 = SocketState_ShutDown_getInstance();
  cancel($this.i6b_1);
  $this.m6b_1 = cause;
  listeners.u2($this.n6b_1.x4());
  $this.n6b_1.y4();
  // Inline function 'kotlin.collections.forEach' call
  var _iterator__ex2g4s = listeners.p1();
  while (_iterator__ex2g4s.q1()) {
    var element = _iterator__ex2g4s.r1();
    element.z6b(cause);
  }
}
function SubscribableWebSocket$restartIdleTimeout$slambda(this$0) {
  return constructCallableReference(($this$launch, $completion) => orPromise($completion, function *($completion) {
    yield* delay(this$0.g6b_1, $completion);
    this$0.e6c(ApolloNetworkException().a4a('WebSocket is idle'), 1001, 'Idle');
    return Unit_instance;
  }), 1);
}
function SubscribableWebSocket$onOpen$slambda(this$0) {
  return constructCallableReference(($this$launch, $completion) => orPromise($completion, function *($completion) {
    send(this$0.p6b_1, yield* this$0.d6b_1.z69($completion));
    return Unit_instance;
  }), 1);
}
function SubscribableWebSocket$onOpen$slambda_0(this$0) {
  return constructCallableReference(($this$launch, $completion) => orPromise($completion, function *($completion) {
    yield* delay(this$0.f6b_1, $completion);
    this$0.e6c(ApolloNetworkException().a4a('Timeout while waiting for connection_ack'), 1001, 'Timeout while waiting for connection_ack');
    return Unit_instance;
  }), 1);
}
function SubscribableWebSocket$onMessage$slambda(this$0) {
  return constructCallableReference(($this$launch, $completion) => orPromise($completion, function *($completion) {
    while (true) {
      yield* delay(this$0.e6b_1, $completion);
      var tmp0_safe_receiver = this$0.d6b_1.c6a();
      if (tmp0_safe_receiver == null)
        null;
      else {
        // Inline function 'kotlin.let' call
        send(this$0.p6b_1, tmp0_safe_receiver);
      }
    }
    return Unit_instance;
  }), 1);
}
function SubscribableWebSocket$onMessage$slambda_0(this$0) {
  return constructCallableReference(($this$launch, $completion) => orPromise($completion, function *($completion) {
    // Inline function 'kotlin.collections.forEach' call
    var _iterator__ex2g4s = this$0.o6b_1.p1();
    while (_iterator__ex2g4s.q1()) {
      var element = _iterator__ex2g4s.r1();
      send(this$0.p6b_1, yield* this$0.d6b_1.a6a(element, $completion));
    }
    return Unit_instance;
  }), 1);
}
function SubscribableWebSocket$startOperation$slambda(this$0, $request) {
  return constructCallableReference(($this$launch, $completion) => orPromise($completion, function *($completion) {
    send(this$0.p6b_1, yield* this$0.d6b_1.a6a($request, $completion));
    return Unit_instance;
  }), 1);
}
function SubscribableWebSocket$stopOperation$slambda(this$0, $request) {
  return constructCallableReference(($this$launch, $completion) => orPromise($completion, function *($completion) {
    send(this$0.p6b_1, this$0.d6b_1.b6a($request));
    return Unit_instance;
  }), 1);
}
var SubscribableWebSocketClass;
function SubscribableWebSocket() {
  if (SubscribableWebSocketClass === VOID) {
    class $ {
      constructor(webSocketEngine, serverUrl, httpHeaders, wsProtocol, pingInterval, connectionAcknowledgeTimeout, idleTimeout) {
        this.d6b_1 = wsProtocol;
        this.e6b_1 = pingInterval;
        this.f6b_1 = connectionAcknowledgeTimeout;
        this.g6b_1 = idleTimeout;
        var tmp = this;
        // Inline function 'kotlinx.atomicfu.locks.reentrantLock' call
        tmp.h6b_1 = get_atomicfu$reentrantLock();
        this.i6b_1 = CoroutineScope(Dispatchers_getInstance().b14_1);
        this.j6b_1 = null;
        this.k6b_1 = null;
        this.l6b_1 = SocketState_AwaitOpen_getInstance();
        this.m6b_1 = null;
        var tmp_0 = this;
        // Inline function 'kotlin.collections.mutableMapOf' call
        tmp_0.n6b_1 = LinkedHashMap().fc();
        var tmp_1 = this;
        // Inline function 'kotlin.collections.mutableListOf' call
        tmp_1.o6b_1 = ArrayList().p2();
        var tmp_2;
        var tmp$ret$3;
        $l$block_0: {
          // Inline function 'kotlin.collections.any' call
          var tmp_3;
          if (isInterface(httpHeaders, Collection())) {
            tmp_3 = httpHeaders.n1();
          } else {
            tmp_3 = false;
          }
          if (tmp_3) {
            tmp$ret$3 = false;
            break $l$block_0;
          }
          var _iterator__ex2g4s = httpHeaders.p1();
          while (_iterator__ex2g4s.q1()) {
            var element = _iterator__ex2g4s.r1();
            // Inline function 'kotlin.text.lowercase' call
            // Inline function 'kotlin.js.asDynamic' call
            if (element.u4b_1.toLowerCase() === 'sec-websocket-protocol') {
              tmp$ret$3 = true;
              break $l$block_0;
            }
          }
          tmp$ret$3 = false;
        }
        if (tmp$ret$3) {
          tmp_2 = httpHeaders;
        } else {
          tmp_2 = plus(httpHeaders, new (HttpHeader())('Sec-WebSocket-Protocol', this.d6b_1.h1()));
        }
        var headers = tmp_2;
        var listener = new (BufferedWebSocketListener())();
        this.p6b_1 = webSocketEngine.f6c(serverUrl, headers, listener);
        listener.j6c(this);
      }
      k6c(markActive) {
        // Inline function 'kotlinx.atomicfu.locks.withLock' call
        this.h6b_1;
        // Inline function 'kotlin.also' call
        var this_0 = this.l6b_1.equals(SocketState_ShutDown_getInstance());
        if (!this_0 && markActive) {
          var tmp0_safe_receiver = this.j6b_1;
          if (tmp0_safe_receiver == null)
            null;
          else {
            tmp0_safe_receiver.hy();
          }
          this.j6b_1 = null;
        }
        return this_0;
      }
      e6c(cause, code, reason) {
        shutdownInternal(this, cause);
        this.p6b_1.l6c(code, reason);
      }
      m6c() {
        // Inline function 'kotlinx.atomicfu.locks.withLock' call
        this.h6b_1;
        if (this.l6b_1.w1_1 === 0) {
          launch(this.i6b_1, VOID, VOID, SubscribableWebSocket$onOpen$slambda(this));
          var tmp = this;
          tmp.k6b_1 = launch(this.i6b_1, VOID, VOID, SubscribableWebSocket$onOpen$slambda_0(this));
          this.l6b_1 = SocketState_AwaitAck_getInstance();
        }
      }
      n6c(text) {
        var message = this.d6b_1.e6a(text);
        if (equals(message, ConnectionAckServerMessage_instance)) {
          var tmp0_safe_receiver = this.k6b_1;
          if (tmp0_safe_receiver == null)
            null;
          else {
            tmp0_safe_receiver.hy();
          }
          this.k6b_1 = null;
          // Inline function 'kotlinx.atomicfu.locks.withLock' call
          this.h6b_1;
          if (!this.l6b_1.equals(SocketState_AwaitAck_getInstance())) {
            return Unit_instance;
          }
          this.l6b_1 = SocketState_Connected_getInstance();
          var tmp = this.e6b_1;
          if (!((tmp == null ? null : new (Duration())(tmp)) == null)) {
            launch(this.i6b_1, VOID, VOID, SubscribableWebSocket$onMessage$slambda(this));
          }
          launch(this.i6b_1, VOID, VOID, SubscribableWebSocket$onMessage$slambda_0(this));
        } else {
          if (message instanceof ConnectionErrorServerMessage()) {
            this.e6c(SubscriptionConnectionException().t4h(message.o6c_1), 1001, 'Connection error');
          } else {
            if (message instanceof ResponseServerMessage()) {
              // Inline function 'kotlinx.atomicfu.locks.withLock' call
              this.h6b_1;
              var tmp1_safe_receiver = this.n6b_1.v4(message.f6a_1);
              if (tmp1_safe_receiver == null)
                null;
              else {
                tmp1_safe_receiver.v6b(message.g6a_1);
              }
            } else {
              if (message instanceof CompleteServerMessage()) {
                // Inline function 'kotlinx.atomicfu.locks.withLock' call
                this.h6b_1;
                var tmp2_safe_receiver = this.n6b_1.v4(message.h6a_1);
                if (tmp2_safe_receiver == null)
                  null;
                else {
                  tmp2_safe_receiver.x6b();
                }
              } else {
                if (message instanceof OperationErrorServerMessage()) {
                  // Inline function 'kotlinx.atomicfu.locks.withLock' call
                  this.h6b_1;
                  var tmp3_safe_receiver = this.n6b_1.v4(message.i6a_1);
                  if (tmp3_safe_receiver == null)
                    null;
                  else {
                    tmp3_safe_receiver.y6b(message.j6a_1);
                  }
                } else {
                  if (message instanceof ParseErrorServerMessage()) {
                    println("Cannot parse message: '" + message.k6a_1 + "'");
                  } else {
                    if (equals(message, PingServerMessage_instance)) {
                      var tmp4_safe_receiver = this.d6b_1.d6a();
                      if (tmp4_safe_receiver == null)
                        null;
                      else {
                        // Inline function 'kotlin.let' call
                        send(this.p6b_1, tmp4_safe_receiver);
                      }
                    } else {
                      if (!equals(message, PongServerMessage_instance)) {
                        if (!equals(message, ConnectionKeepAliveServerMessage_instance)) {
                          noWhenBranchMatchedException();
                        }
                      }
                    }
                  }
                }
              }
            }
          }
        }
      }
      p6c(data) {
        this.n6c(decodeToString(data));
      }
      q6c(cause) {
        shutdownInternal(this, cause);
      }
      r6c(code, reason) {
        shutdownInternal(this, ApolloWebSocketClosedException().t4g(code == null ? 1001 : code, reason));
      }
      q6b(request, listener) {
        var cause = null;
        // Inline function 'kotlinx.atomicfu.locks.withLock' call
        this.h6b_1;
        var tmp0_safe_receiver = this.j6b_1;
        if (tmp0_safe_receiver == null)
          null;
        else {
          tmp0_safe_receiver.hy();
        }
        this.j6b_1 = null;
        var tmp;
        switch (this.l6b_1.w1_1) {
          case 0:
          case 1:
            this.n6b_1.b5(request.q43_1.toString(), listener);
            tmp = this.o6b_1.j2(request);
            break;
          case 2:
            this.n6b_1.b5(request.q43_1.toString(), listener);
            tmp = launch(this.i6b_1, VOID, VOID, SubscribableWebSocket$startOperation$slambda(this, request));
            break;
          case 3:
            cause = DefaultApolloException().m45('Apollo: the WebSocket is shut down', this.m6b_1);
            tmp = Unit_instance;
            break;
          default:
            noWhenBranchMatchedException();
            break;
        }
        if (!(cause == null)) {
          listener.z6b(ensureNotNull(cause));
        }
      }
      r6b(request) {
        var id = request.q43_1.toString();
        // Inline function 'kotlinx.atomicfu.locks.withLock' call
        this.h6b_1;
        if (this.n6b_1.t4(id)) {
          this.n6b_1.c5(id);
          launch(this.i6b_1, VOID, VOID, SubscribableWebSocket$stopOperation$slambda(this, request));
          if (this.n6b_1.n1()) {
            restartIdleTimeout(this);
          }
        }
      }
    }
    initMetadataForClass($, 'SubscribableWebSocket');
    SubscribableWebSocketClass = $;
  }
  return SubscribableWebSocketClass;
}
var static_init_called;
function static_init() {
  if (static_init_called)
    return Unit_instance;
  static_init_called = true;
  SocketState_AwaitOpen_instance = new (SocketState())('AwaitOpen', 0);
  SocketState_AwaitAck_instance = new (SocketState())('AwaitAck', 1);
  SocketState_Connected_instance = new (SocketState())('Connected', 2);
  SocketState_ShutDown_instance = new (SocketState())('ShutDown', 3);
}
var SocketState_AwaitOpen_instance;
var SocketState_AwaitAck_instance;
var SocketState_Connected_instance;
var SocketState_ShutDown_instance;
var SocketStateClass;
function SocketState() {
  if (SocketStateClass === VOID) {
    class $ extends Enum() {}
    initMetadataForClass($, 'SocketState');
    SocketStateClass = $;
  }
  return SocketStateClass;
}
function dispatch($this, callback) {
  // Inline function 'kotlinx.atomicfu.locks.withLock' call
  $this.g6c_1;
  // Inline function 'kotlin.also' call
  var this_0 = $this.h6c_1;
  if (this_0 == null) {
    $this.i6c_1.j2(callback);
  }
  var target = this_0;
  if (!(target == null)) {
    callback(target);
  }
}
function BufferedWebSocketListener$onOpen$lambda(it) {
  it.m6c();
  return Unit_instance;
}
var BufferedWebSocketListenerClass;
function BufferedWebSocketListener() {
  if (BufferedWebSocketListenerClass === VOID) {
    class $ {
      constructor() {
        var tmp = this;
        // Inline function 'kotlinx.atomicfu.locks.reentrantLock' call
        tmp.g6c_1 = get_atomicfu$reentrantLock();
        this.h6c_1 = null;
        var tmp_0 = this;
        // Inline function 'kotlin.collections.mutableListOf' call
        tmp_0.i6c_1 = ArrayList().p2();
      }
      j6c(target) {
        while (true) {
          // Inline function 'kotlinx.atomicfu.locks.withLock' call
          this.g6c_1;
          if (this.i6c_1.n1()) {
            this.h6c_1 = target;
            return Unit_instance;
          }
          // Inline function 'kotlin.also' call
          var this_0 = toList(this.i6c_1);
          this.i6c_1.y4();
          var callbacks = this_0;
          // Inline function 'kotlin.collections.forEach' call
          var _iterator__ex2g4s = callbacks.p1();
          while (_iterator__ex2g4s.q1()) {
            var element = _iterator__ex2g4s.r1();
            element(target);
          }
        }
      }
      m6c() {
        return dispatch(this, BufferedWebSocketListener$onOpen$lambda);
      }
      n6c(text) {
        return dispatch(this, (it) => {
          it.n6c(text);
          return Unit_instance;
        });
      }
      p6c(data) {
        return dispatch(this, (it) => {
          it.p6c(data);
          return Unit_instance;
        });
      }
      q6c(cause) {
        return dispatch(this, (it) => {
          it.q6c(cause);
          return Unit_instance;
        });
      }
      r6c(code, reason) {
        return dispatch(this, (it) => {
          it.r6c(code, reason);
          return Unit_instance;
        });
      }
    }
    initMetadataForClass($, 'BufferedWebSocketListener', BufferedWebSocketListener);
    BufferedWebSocketListenerClass = $;
  }
  return BufferedWebSocketListenerClass;
}
function send(_this__u8e3s4, clientMessage) {
  if (clientMessage instanceof TextClientMessage()) {
    _this__u8e3s4.u6c(clientMessage.w69_1);
  } else {
    if (clientMessage instanceof DataClientMessage()) {
      _this__u8e3s4.t6c(clientMessage.s6c_1);
    } else {
      noWhenBranchMatchedException();
    }
  }
}
function SocketState_AwaitOpen_getInstance() {
  static_init();
  return SocketState_AwaitOpen_instance;
}
function SocketState_AwaitAck_getInstance() {
  static_init();
  return SocketState_AwaitAck_instance;
}
function SocketState_Connected_getInstance() {
  static_init();
  return SocketState_Connected_instance;
}
function SocketState_ShutDown_getInstance() {
  static_init();
  return SocketState_ShutDown_instance;
}
//region block: exports
export {
  SubscribableWebSocket as SubscribableWebSockethkxzhdarcovi,
};
//endregion

//# sourceMappingURL=SubscribableWebSocket.mjs.map
